import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Typography,
} from "@mui/material";
import React from "react";

type Properties = {
  done: number;
  fail: any[];
  skipped: any[];
  todo: number;
};

type InfoOverviewProps = {
  info: {
    internal: Properties;
    lead: Properties;
    partner: Properties;
    subscriber: Properties;
    trial: Properties;
    total: {
      done: number;
      fail: number;
      skipped: number;
      todo: number;
    };
  };
  title: string;
  type: "END" | "START";
  isSending: boolean;
};

const propMap = [
  { label: "Subscribers", key: "subscriber" },
  { label: "Trials", key: "trial" },
  { label: "Leads", key: "lead" },
  { label: "Partners", key: "partner" },
  { label: "Internals", key: "internal" },
  { label: "Free", key: "free" },
];
export default function InfoOverview({
  info,
  title,
  type,
  isSending,
}: InfoOverviewProps) {
  return (
    <Card sx={{ boxShadow: 3 }}>
      <CardContent>
        <Box display={"flex"} gap={2} flexDirection={"column"}>
          <Typography variant="subtitle1">{title}</Typography>
          <Box display={"flex"} flexDirection={"column"}>
            {isSending && (
              <Box alignItems={"center"} display={"flex"} gap={2}>
                <CircularProgress size={15} color="secondary" />

                <Typography>
                  <strong>Sending emails...</strong>{" "}
                </Typography>
              </Box>
            )}
            {type === "START" &&
              !isSending &&
              propMap.map((item, index) => (
                <Typography key={index}>
                  <strong>{item.label}</strong>:{info[item.key].todo}
                </Typography>
              ))}

            {type === "END" &&
              !isSending &&
              propMap.map((item, index) => (
                <Typography key={index}>
                  <strong>{item.label}</strong>: {info[item.key].done}/
                  {info[item.key].todo}
                </Typography>
              ))}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
